import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const PriceAlertModal = ({ stock, onClose, onSave }) => {
  const [alertType, setAlertType] = useState("above");
  const [targetPrice, setTargetPrice] = useState(stock ? (stock?.price * 1.05)?.toFixed(2) : "");
  const [notify, setNotify] = useState("in-app");
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => {
      onSave && onSave({ stock, alertType, targetPrice: parseFloat(targetPrice), notify });
      onClose();
    }, 800);
  };

  if (!stock) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.85)" }}>
      <div className="w-full max-w-sm bg-card border border-border rounded-xl shadow-2xl" style={{ boxShadow: "var(--glow-md)" }}>
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name="Bell" size={16} color="var(--color-primary)" />
            <span className="font-heading text-sm font-semibold text-foreground">Price Alert</span>
            <span className="font-caption text-xs text-primary bg-primary/10 px-2 py-0.5 rounded">{stock?.ticker}</span>
          </div>
          <button onClick={onClose} className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-primary/10 transition-all">
            <Icon name="X" size={14} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          {/* Current Price */}
          <div className="flex items-center justify-between p-3 rounded-lg bg-secondary border border-border">
            <span className="font-caption text-xs text-muted-foreground">Current Price</span>
            <span className="font-data text-sm font-bold text-foreground">${stock?.price?.toFixed(2)}</span>
          </div>

          {/* Alert Type */}
          <div>
            <label className="font-caption text-xs text-muted-foreground uppercase tracking-wider mb-2 block">Alert When Price Is</label>
            <div className="grid grid-cols-2 gap-2">
              {["above", "below"]?.map(t => (
                <button key={t} onClick={() => setAlertType(t)}
                  className={`py-2 rounded-lg font-caption text-xs font-medium capitalize transition-all ${alertType === t ? "bg-primary/20 text-primary border border-primary/40" : "bg-secondary text-muted-foreground border border-border hover:border-primary/30"}`}>
                  {t === "above" ? "↑ Above" : "↓ Below"}
                </button>
              ))}
            </div>
          </div>

          {/* Target Price */}
          <div>
            <label className="font-caption text-xs text-muted-foreground uppercase tracking-wider mb-2 block">Target Price ($)</label>
            <input type="number" value={targetPrice} onChange={e => setTargetPrice(e?.target?.value)} step="0.01"
              className="w-full py-2 px-3 bg-secondary border border-border rounded-lg font-data text-sm text-foreground focus:outline-none focus:border-primary/50 focus:ring-1 focus:ring-primary/30" />
          </div>

          {/* Notification Method */}
          <div>
            <label className="font-caption text-xs text-muted-foreground uppercase tracking-wider mb-2 block">Notify Via</label>
            <div className="grid grid-cols-2 gap-2">
              {[{ v: "in-app", label: "In-App" }, { v: "email", label: "Email" }]?.map(n => (
                <button key={n?.v} onClick={() => setNotify(n?.v)}
                  className={`py-2 rounded-lg font-caption text-xs font-medium transition-all ${notify === n?.v ? "bg-accent/20 text-accent border border-accent/40" : "bg-secondary text-muted-foreground border border-border hover:border-accent/30"}`}>
                  {n?.label}
                </button>
              ))}
            </div>
          </div>

          <Button variant="default" fullWidth loading={saved} onClick={handleSave} iconName="Bell" iconPosition="left">
            {saved ? "Alert Set!" : "Set Price Alert"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PriceAlertModal;